<template>    
    <div class="ly-bill p10">
        <div class="el-row ly-bill-title">
            <el-col :span="12">
                <h1 style="padding-top:5px;">功能权限开关管理</h1>
            </el-col>
        </div>

        <el-card class="box-card mt15">
            <el-table :data="tableData">
                <el-table-column
                   type="index"
                   width="50">
                </el-table-column>
                <el-table-column
                    prop="gongneng_name"
                    label="功能权限开关名称">
                </el-table-column>
                <el-table-column
                    label="状态开关"
                    width="200">
                    <template slot-scope="scope">
                        <span v-if="!scope.row.status">否</span>
                        <span v-else>是</span>
                    </template>                    
                </el-table-column>
                <el-table-column
                    label="操作"
                    width="180">
                    <template slot-scope="scope">
                        <el-switch
                            v-model="scope.row.status"
                            on-text=""
                            off-text=""
                            @change="statusChange(scope.row)">
                        </el-switch>
                    </template>
                </el-table-column>
            </el-table>
        </el-card>
    </div>
</template>
<script>
    export default {
        data () {
            return {
                tableData: [{
                    date: '2018-9-01',
                    name: '123123',
                    switch: true
                }]
            }
        },
        created () {
            this.queryData()
        },
        methods: {
            queryData () {
                this.$api.query('api/gongnengquanxian').then((rs) => {
                    this.tableData = rs
                }).catch((err) => {                    
                    this.$message({
                        message: err,
                        type: 'warning'
                    })
                })
            },
            /**
             * 开关状态的选择
             */
            statusChange (row) {
                this.$api.create('api/gongnengquanxian', row).then((rs) => {         
                    this.$message({
                        message: '操作成功',
                        type: 'success'
                    })
                }).catch((err) => {                    
                    this.$message({
                        message: err,
                        type: 'warning'
                    })
                })
            }
        }
    }
</script>